import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CustomizedSnackbars from '../material-snackbars';
import { detectBrowserForSpellCheckHelp, SPELLCHECK_SETTINGS_PATH } from '../../helpers/spellcheck';

const BROWSER_LABELS = {
  chrome: 'Google Chrome',
  edge: 'Microsoft Edge',
  firefox: 'Mozilla Firefox',
  safari: 'Safari',
  other: 'seu navegador',
};

const INSTRUCTIONS = {
  chrome: '1. Abra uma nova aba e acesse o endereço abaixo.\n2. Na seção "Verificação ortográfica", ative a opção.\n3. Confira se o idioma desejado (Português, Inglês ou Espanhol) está ativado na lista.',
  edge: '1. Abra uma nova aba e acesse o endereço abaixo.\n2. Na seção "Verificação ortográfica", ative a opção.\n3. Confira se o idioma desejado está ativado na lista.',
  firefox: '1. Abra uma nova aba e acesse o endereço abaixo.\n2. Na seção "Idioma e Aparência", marque a opção "Verificar ortografia ao digitar".',
  safari: '1. No menu superior, clique em Editar > Ortografia e Gramática > Verificar Ortografia ao Digitar.\n2. Confira os idiomas em Ajustes do Sistema > Geral > Idioma e Região.',
  other: 'Não conseguimos identificar seu navegador automaticamente. Procure por "verificação ortográfica" nas configurações de idioma do seu navegador.',
};

function SpellcheckHelpDialog(props) {
  const { open, onClose } = props;
  const [copySuccess, setCopySuccess] = useState(false);

  const browser = detectBrowserForSpellCheckHelp();
  const settingsPath = SPELLCHECK_SETTINGS_PATH[browser];

  const handleCopyPath = async () => {
    try {
      await navigator.clipboard.writeText(settingsPath);
      setCopySuccess(true);
    } catch (e) {
      // Clipboard API indisponível (contexto não seguro, permissão negada, etc.):
      // usuário ainda pode copiar o endereço manualmente do texto exibido.
    }
  };

  return (
    <>
      <CustomizedSnackbars
        variant="success"
        message="Endereço copiado!"
        isOpen={copySuccess}
        toClose={() => setCopySuccess(false)}
      />
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="spellcheck-help-dialog-title">
        <DialogTitle id="spellcheck-help-dialog-title">
          Corretor ortográfico do navegador
        </DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            O corretor ortográfico usado no Mexx 2do é o recurso nativo do seu navegador. Se ele não estiver ativo, siga as instruções abaixo para o seu navegador.
          </Typography>
          <Typography variant="subtitle1" style={{ marginTop: 16, fontWeight: 'bold' }}>
            {BROWSER_LABELS[browser]}
          </Typography>
          <Typography style={{ whiteSpace: 'pre-line', marginTop: 8 }}>
            {INSTRUCTIONS[browser]}
          </Typography>
          {settingsPath && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 16, padding: 12, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
              <Typography style={{ fontFamily: 'monospace', flex: 1 }}>{settingsPath}</Typography>
              <Button size="small" startIcon={<ContentCopyIcon />} onClick={handleCopyPath}>
                Copiar endereço
              </Button>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SpellcheckHelpDialog;
